import axios from "axios";
import API_BASE_URL from "../config";
export const FETCH_RIGHT_SIDEBAR_SUCCESS = "FETCH_RIGHT_SIDEBAR_SUCCESS";
export const FETCH_RIGHT_SIDEBAR_FAILURE = "FETCH_RIGHT_SIDEBAR_FAILURE";
export const TOGGLE_RIGHT_CATEGORY = "TOGGLE_RIGHT_CATEGORY";
export const SELECT_RIGHT_SUBCATEGORY = "SELECT_RIGHT_SUBCATEGORY";
export const SET_SLIDING_STATE = "SET_SLIDING_STATE";



export const fetchRightSidebarSuccess = (data) => ({
  type: FETCH_RIGHT_SIDEBAR_SUCCESS,
  payload: data,
});

export const fetchRightSidebarFailure = (error) => ({
  type: FETCH_RIGHT_SIDEBAR_FAILURE,
  payload: error,
});

export const toggleRightCategory = ({ categoryId, subcategories }) => ({
  type: TOGGLE_RIGHT_CATEGORY,
  payload: { categoryId, subcategories },
});

export const selectRightSubcategory = (categoryId) => ({
  type: SELECT_RIGHT_SUBCATEGORY,
  payload: categoryId, 
});

export const setSlidingState = (isSliding) => ({
  type: SET_SLIDING_STATE,
  payload: isSliding,
});


export const fetchRightSidebarData = () => async (dispatch) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/rightsidebar`);
    dispatch(fetchRightSidebarSuccess(response.data));
  } catch (error) {
    console.error("Error fetching right sidebar categories:", error);
    dispatch(fetchRightSidebarFailure("Failed to fetch categories"));
  }
};

// Fetch subcategories dynamically when hovering over a category
export const fetchRightSidebarSubcategories = (categoryId) => async (dispatch) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/rightsidebar/${categoryId}`);
    dispatch(toggleRightCategory({ categoryId, subcategories: response.data }));
  } catch (error) {
    console.error(`Error fetching subcategories for category ID ${categoryId}:`, error);
    dispatch(fetchRightSidebarFailure("Failed to fetch subcategories"));
  }
};






